import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';

import classes from './SpecificSection.module.css';

const SpecificSection = ({ productData }) => {
  return (
    <div className={classes.specificSectionContainer}>
      <figure className={classes.imgCourse}>
        <img
          className={classes.img}
          src={productData.img}
          alt={productData.title}
        />
      </figure>
      <Button
        className={classes.btnPay}
        component={Link}
        to="/preregister"
      >
        Proceso de inscripción
      </Button>
      <aside className={classes.itemsDescriptionsContainer}>
        <p className={classes.itemDescriptionContainer}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/revoe.png"
            />
          </figure>
          <span className={classes.textItem}>
            {productData.RVOE}
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/modalidad_01.png"
            />
          </figure>
          <span className={classes.textItem}>
            Modalidad: {productData.modality}
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/duracion_01.png"
            />
          </figure>
          <span className={classes.textItem}>
            Duración: {productData.duration} Semestres
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/inicioSemestre_01.png"
            />
          </figure>
          <span className={classes.textItem}>
            Inicio semestral: {productData.start}
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/materias_01.png"
            />
          </figure>
          <span className={classes.textItem}>
            {productData.subjetcs} Materias
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_creditos.png"
            />
          </figure>
          <span className={classes.textItem}>
            Creditos: {productData.credits}
          </span>
        </p>
        <p className={classes.moreInfo}>Más información</p>
        {productData.downloadFiles.map(item => (
          <a
            key={item.link}
            href={item.link}
            target="_blank"
            className={classes.linkSpecific}
            rel="noreferrer"
          >
            <figure className={classes.productIcon}>
              <img className={classes.img} src={item.icon} alt="" />
            </figure>
            <span className={classes.textItem}>{item.text}</span>
          </a>
        ))}
      </aside>
    </div>
  );
};

SpecificSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productData: PropTypes.object
};

export default SpecificSection;
